import { render, staticRenderFns } from "./InformePresupuesto.vue?vue&type=template&id=2672e203&"
import script from "./InformePresupuesto.vue?vue&type=script&lang=js&"
export * from "./InformePresupuesto.vue?vue&type=script&lang=js&"
import style0 from "./InformePresupuesto.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports